import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const AccessLogsView = () => import("./views/AccessLogsView.vue");
const AdminHome = () => import("./views/AdminHome.vue");
const AdminShell = () => import("./views/AdminShell.vue");
const AuditLogsView = () => import("./views/AuditLogsView.vue");
const EmployeeHomeView = () => import("./views/EmployeeHomeView.vue");
const EmployeeAccountsView = () => import("./views/EmployeeAccountsView.vue");
const LoginView = () => import("./views/LoginView.vue");
const SampleEditView = () => import("./views/SampleEditView.vue");
const SampleListView = () => import("./views/SampleListView.vue");
const ScanLauncherView = () => import("./views/ScanLauncherView.vue");
const ScanView = () => import("./views/ScanView.vue");

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: LoginView },
  { path: "/employee", component: EmployeeHomeView },
  { path: "/scan", component: ScanLauncherView },
  { path: "/s/:token", component: ScanView },
  {
    path: "/admin",
    component: AdminShell,
    meta: { staffOnly: true },
    children: [
      { path: "", component: AdminHome },
      { path: "samples", component: SampleListView, meta: { sampleRead: true } },
      {
        path: "samples/new",
        component: SampleEditView,
        meta: { sampleManage: true, sampleCreate: true }
      },
      { path: "samples/:id", component: SampleEditView, meta: { sampleRead: true } },
      { path: "samples/:id/edit", component: SampleEditView, meta: { sampleManage: true } },
      { path: "users", component: EmployeeAccountsView, meta: { adminOnly: true } },
      { path: "logs/access", component: AccessLogsView, meta: { adminOnly: true } },
      { path: "logs/audit", component: AuditLogsView, meta: { adminOnly: true } }
    ]
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to) => {
  if (!to.matched.some((record) => record.meta.adminOnly || record.meta.staffOnly)) {
    return true;
  }

  try {
    const response = await fetch("/api/auth/me", {
      credentials: "include",
      cache: "no-store"
    });

    if (!response.ok) {
      return "/login";
    }

    const user = (await response.json()) as { role?: string };

    if (to.matched.some((record) => record.meta.adminOnly)) {
      return user.role === "ADMIN" ? true : "/admin";
    }

    if (to.matched.some((record) => record.meta.sampleManage)) {
      if (user.role === "VIEWER") {
        const id = Array.isArray(to.params.id) ? to.params.id[0] : to.params.id;
        return id ? `/admin/samples/${encodeURIComponent(String(id))}` : "/admin/samples";
      }

      if (
        to.matched.some((record) => record.meta.sampleCreate) &&
        user.role !== "ADMIN" &&
        user.role !== "SAMPLE_MANAGER"
      ) {
        return "/admin/samples";
      }

      return true;
    }

    if (to.matched.some((record) => record.meta.sampleRead)) {
      return true;
    }

    return user.role === "VIEWER" ? "/employee" : true;
  } catch {
    return "/login";
  }
});
